import UntrusiveLoader from "untrusive";

export const Untrusive = new UntrusiveLoader({
  bgColor: "gray",
  barColor: "black",
});
